<template>
  <div class="head">
    <div class="container">
      <nav class="navbar navbar-default" role="navigation">
        <div class="container-fluid">
          <div class="navbar-header">
            <button
              type="button"
              class="navbar-toggle"
              data-toggle="collapse"
              data-target="#example-navbar-collapse"
            >
              <span class="sr-only">切换导航</span>
              <span class="icon-bar"></span>
              <span class="icon-bar"></span>
              <span class="icon-bar"></span>
            </button>
            <a class="navbar-brand" href="#">
              <img alt="Brand" :src="logo" />
            </a>
          </div>
          <div class="collapse navbar-collapse" id="example-navbar-collapse">
            <ul class="nav navbar-nav navbar-right">
              <li
                class="hvr-grow"
                :class="activeIndex == item.index && 'active'"
                @click="jump(item)"
                v-for="item in menus"
                :key="item.index"
              >
                <a href="#">{{ item.text }}</a>
              </li>
              <li class="hvr-grow">
                <a href="tel:400-6919-019">
                  <span
                    class="glyphicon glyphicon-earphone"
                    aria-hidden="true"
                  ></span>
                  400-6919-019
                </a>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </div>
  </div>
</template>

<script>
import logo from "@/assets/images/logo.png";

const menus = [
  { index: "home", text: "首页" },
  { index: "scene", text: "合同场景" },
  { index: "case", text: "合同案例" },
  { index: "about", text: "关于我们" },
];
export default {
  data() {
    return {
      logo,
      menus,
      activeIndex: "",
    };
  },
  methods: {
    jump(r) {
      this.activeIndex = r.index;
      this.$router.push({
        name: r.index,
      });

      // 收起
      window.$("#example-navbar-collapse").removeClass("in");
    },
  },
  watch: {
    $route(to) {
      //监视路由变化
      if (this.activeIndex != to.name) {
        this.activeIndex = to.name;
      }
    },
  },
  mounted() {
    let name = this.$route.name;
    this.activeIndex = name;
  },
};
</script>

<style scoped>
.head {
  position: absolute;
  z-index: 999;
  width: 100%;
  top: 0;
}

/*  */
.navbar-default {
  background-color: inherit;
  border: none;
  margin-top: 20px;
}
.navbar-default .navbar-nav > li > a {
  color: #fff;
}
.navbar-default .navbar-nav > .active > a,
.navbar-default .navbar-nav > .active > a:focus,
.navbar-default .navbar-nav > .active > a:hover {
  color: #f6c946;
  background-color: transparent;
}
.navbar-brand {
  padding: 0;
}
.navbar-brand > img {
  display: block;
  height: 100%;
}
.navbar-default .navbar-toggle {
  border-color: #fff;
}
.navbar-default .navbar-toggle .icon-bar {
  background-color: #fff;
}
.navbar-default .navbar-toggle:focus,
.navbar-default .navbar-toggle:hover {
  background-color: transparent;
}

/*  */
.mb .navbar-default .navbar-collapse {
  background-color: #2f56ce;
  border: none;
  box-shadow: none;
}
</style>